module.exports = __webpack_public_path__ + "static/media/img6.e19b6ef3.png";